// Vorname und Nachname (seit E3b, O82 – Manuel am Telefon, 22.10.2026, über
// Gernot: für Auswertungen und die Arbeit mit den Daten später; Titel nicht).
//
// Der Name, den alle Listen zeigen, bleibt EIN Feld („name“) – so schickt ihn
// auch jedes Gerät mit altem Stand. Wer Vor- und Nachname getrennt hat, für
// den setzt diese Regel den Namen zusammen: „Vorname Nachname“, ohne
// Vorname nur der Nachname. Doku-App und Server nehmen dieselbe Regel
// (Prüfung des Plans E3b, Befund 5) – der Server nur, wenn ein Nachname
// mitkommt.
//
// Bestehende Kunden bleiben, wie sie sind (Claudes Vorschlag 4): Nichts wird
// still umgeschrieben. Beim nächsten „Kunde berichtigen“ steht ein Vorschlag
// da – das letzte Wort ist der Nachname, Anrede und Titel fallen weg
// („Familie Huber“ → Nachname „Huber“; nach dem Aufteilen heißt sie in den
// Listen „Huber“).

/** Der Name, wie ihn alle Listen zeigen: „Vorname Nachname“ – ohne Vorname nur der Nachname. */
export function vollerName(vorname: string | null | undefined, nachname: string | null | undefined): string {
  return [vorname, nachname]
    .map((t) => (t ?? "").trim().replace(/\s+/g, " "))
    .filter(Boolean)
    .join(" ");
}

/** Anrede und Titel, die beim Vorschlag wegfallen – nur ganze Wörter, ohne Rücksicht auf Groß- und Kleinschreibung. */
const OHNE = new Set(["familie", "fam", "frau", "fr", "herr", "hr", "dr", "mag", "ing", "di", "dipl", "prof", "msc", "bsc", "ma", "ba", "mba", "dkfm"]);

/**
 * Ein Vorschlag, wie ein Name aus einem Feld aufzuteilen ist: das letzte Wort
 * der Nachname, die Wörter davor der Vorname – Anrede und Titel fallen weg
 * („Frau Dr. Maria Huber“ → Maria / Huber; „Familie Huber“ → – / Huber).
 * Ein Vorschlag, keine Entscheidung: Das Büro sieht ihn und berichtigt.
 */
export function namensVorschlag(name: string): { vorname: string; nachname: string } {
  const woerter = name
    .trim()
    .split(/\s+/)
    .filter((w) => w !== "" && !OHNE.has(w.replace(/[.,]/g, "").toLocaleLowerCase("de-AT")));
  if (woerter.length === 0) return { vorname: "", nachname: name.trim() };
  return { vorname: woerter.slice(0, -1).join(" "), nachname: woerter[woerter.length - 1]! };
}
